export const isUserV2Customer = () => {
    const dateUpgraded = localStorage.getItem("dateUpgraded");
// these are the dates where the new pricing will be shown
    const dateAICutoff = new Date("2025-09-07")
// Convert to Date object
    if (dateUpgraded !== null && dateUpgraded !== undefined && dateUpgraded !== "null") {
        try{
            const dateUpgradedObj = new Date(dateUpgraded);
            const dateAIObj = new Date(dateAICutoff);

            if (dateUpgradedObj < dateAIObj) {
                return true
            }
        } catch(err) { return false }
    }

    return false
}

